import { useMemo } from 'react'

import { useApiRequest } from '@tabeeb/shared/utils/hooks'

import { getAiModelAiObjects } from '../actions'
import { AIModelAIObjectResponse } from '../types'

interface UseAIModelAIObjectsHookProps {
  id: number
  onError: (error: unknown) => void
}

interface UseAIModelAIObjectsHookState {
  loading: boolean
  aiObjects: AIModelAIObjectResponse[] | null
  abortRequest: () => void
}

export default ({ id, onError }: UseAIModelAIObjectsHookProps): UseAIModelAIObjectsHookState => {
  const payload = useMemo(() => ({ aiModelId: id }), [id])

  const {
    loading,
    response: aiObjects,
    abortRequest,
  } = useApiRequest({ request: getAiModelAiObjects.request, payload, onError })

  return { loading, aiObjects, abortRequest }
}
